import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=c4657e3e&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=c4657e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4657e3e",
  null
  
)

export default component.exports